import { parseJwt, JwtPayload } from "@granular/fabric3-definitions";
import { useMemo } from "react";
import { useAuth } from "../services/auth/useAuth";

export function useJwtUser(): JwtPayload | undefined {
  const { renderingToken } = useAuth();

  const claims = useMemo(() => {
    return parseJwt(renderingToken);
  }, [renderingToken]);

  return claims;
}
